import { useSelector, useDispatch } from 'react-redux'
import classNames from 'classnames'
import { addToAvailabilityQueue } from '../../store/ui/actions'
import { useEffect } from 'react'
import styles from './styles/AGCheckAvailability.css'
import Link from 'components/misc/Link'
import * as analytics from 'lib/analytics'

//
// TODO (Ashish): Clean this up by reconciling
//   with the logic on the API by
//   passing better metadata in user object
//   about whether we have a shared license.
//
const JOINT_B2B_SCITE_AG_LICENSES = [
  'boehringer-ingelheim',
  'research-solutions'
]

const DEFAULT_AG_COPY = 'Access with Article Galaxy'

const AGCheckAvailabilityButton = ({ agCta, handleClickFn, referenceStyle, showCompactLinks }) => {
  return (
    <>
      {referenceStyle && '|'}
      <Link
        blue underline className={classNames({
          [styles.referenceLink]: referenceStyle,
          [styles.link]: !referenceStyle,
          [styles.compactLink]: showCompactLinks
        })} onClick={handleClickFn}
      >
        {agCta}
      </Link>
    </>
  )
}

const renderPriceString = (price) => {
  return `$${Number(price).toFixed(2)}`
}

const AGCheckAvailability = ({
  doi,
  referenceStyle = false,
  showCompactLinks = false
}) => {
  const dispatch = useDispatch()
  const user = useSelector(({ ui }) => ui.user)
  const availabilityState = useSelector(({ ui }) => ui.agAvailabilityState?.[doi])

  //
  // In general, we should show this for B2C users or for B2B Joint AG / scite
  //  We disable it for B2B scite licenses that are not included in AG.
  //
  const shouldShowAGAvailbility = (
    user?.signupType === 'ag-sso' ||
    (user && !user.organizationLicense) ||
    (user && JOINT_B2B_SCITE_AG_LICENSES.includes(user.organizationLicense))
  )

  useEffect(() => {
    if (shouldShowAGAvailbility && !availabilityState && doi) {
      dispatch(addToAvailabilityQueue(doi))
    }
  }, [shouldShowAGAvailbility, doi, availabilityState])

  if (!shouldShowAGAvailbility || !availabilityState) {
    return null
  }

  // For B2C users, it should just say "Access with Article Galaxy instead of pricing"
  const showAGPricingCopy = user && (user.organizationLicense || user.signupType === 'ag-sso')

  const handleCtaClick = ({ ctaLink, doi, ctaType }) => {
    analytics.event({
      category: 'Article Galaxy',
      action: 'Click Check Availability Link',
      label: showAGPricingCopy ? ctaType : 'default'
    })
    window.open(ctaLink)
  }

  if (availabilityState.ctaPurchasePriceUsd && availabilityState.ctaRentalPriceUsd) {
    if (!showAGPricingCopy) {
      // Don't double show
      return (
        <AGCheckAvailabilityButton
          handleClickFn={() => handleCtaClick({ ctaLink: availabilityState.ctaDefaultLink, doi, ctaType: 'default' })}
          agCta={DEFAULT_AG_COPY}
          referenceStyle={referenceStyle}
          showCompactLinks={showCompactLinks}
        />
      )
    }
    return (
      <>
        <AGCheckAvailabilityButton
          handleClickFn={() => handleCtaClick({ ctaLink: availabilityState.ctaDefaultLink, doi, ctaType: 'purchase' })}
          agCta={`Purchase for ${renderPriceString(availabilityState.ctaPurchasePriceUsd)}`}
          referenceStyle={referenceStyle}
          showCompactLinks={showCompactLinks}
        />
        <AGCheckAvailabilityButton
          handleClickFn={() => handleCtaClick({ ctaLink: availabilityState.ctaDefaultLink, doi, ctaType: 'rent' })}
          agCta={`Rent for ${renderPriceString(availabilityState.ctaRentalPriceUsd)}`}
          referenceStyle={referenceStyle}
          showCompactLinks={showCompactLinks}
        />
      </>
    )
  }

  if (availabilityState.ctaPurchasePriceUsd) {
    return (
      <AGCheckAvailabilityButton
        handleClickFn={() => handleCtaClick({ ctaLink: availabilityState.ctaDefaultLink, doi, ctaType: showAGPricingCopy ? 'purchase' : 'default' })}
        agCta={showAGPricingCopy ? `Purchase for ${renderPriceString(availabilityState.ctaPurchasePriceUsd)}` : DEFAULT_AG_COPY}
        referenceStyle={referenceStyle}
        showCompactLinks={showCompactLinks}
      />
    )
  }

  if (availabilityState.ctaDefaultCopy) {
    return (
      <AGCheckAvailabilityButton
        handleClickFn={() => handleCtaClick({ ctaLink: availabilityState.ctaDefaultLink, doi, ctaType: availabilityState.ctaDefaultType })}
        agCta={availabilityState.ctaDefaultCopy}
        referenceStyle={referenceStyle}
        showCompactLinks={showCompactLinks}
      />
    )
  }
}
export default AGCheckAvailability
